module.exports = __webpack_public_path__ + "static/media/tada.b08dd849.svg";